// extracted by mini-css-extract-plugin
module.exports = {"label":"FormSectionTitle_label__P10B2","subtitle":"FormSectionTitle_subtitle__voa8E"};